// extracted by mini-css-extract-plugin
export var footer = "_ow-0";
export var inherit = "_ow-1";
export var input = "_ow-2";
export var modalContent = "_ow-3";
export var quillEditor = "_ow-4";
export var subtitle = "_ow-5";